import { render, staticRenderFns } from "./addConcatDialog.vue?vue&type=template&id=0bcf2b1f&scoped=true"
import script from "./addConcatDialog.vue?vue&type=script&lang=js"
export * from "./addConcatDialog.vue?vue&type=script&lang=js"
import style0 from "./addConcatDialog.vue?vue&type=style&index=0&id=0bcf2b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf2b1f",
  null
  
)

export default component.exports